import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner  } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'


import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import { AutoComplete as MUIAutoComplete } from 'material-ui'
import { AutoComplete, } from 'redux-form-material-ui'



const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const errors = {}

    //--------------------------------------------------------------------------------------------------------
    const requiredFields = [
        'sexo'
    ]
    const requiredFields2 = [
        'discapacidad'
    ]
    const requiredFields3 = [
        'discapacidaddescripcion'
    ]
    const requiredFields4 = [
        'aptitud'
    ]
    const requiredFields5 = [
        'nivel'
    ]
    const requiredFields6 = [
        'nivel2'
    ]
    const requiredFields7 = [
        'grupo'
    ]


    const requiredFieldsAnoNacimiento = [
        'ano_nacimiento'
    ]
    const requiredFieldsMesNacimiento = [
        'mes_nacimiento'
    ]
    const requiredFieldsDiaNacimiento = [
        'dia_nacimiento'
    ]

  


    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar tipo sexo del alumno';
        }
    })


    requiredFieldsAnoNacimiento.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar año nacimiento';
        }
    })


    requiredFieldsMesNacimiento.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar mes nacimiento';
        }
    })


    requiredFieldsDiaNacimiento.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar día nacimiento';
        }
    })


    requiredFields2.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar la discapacidad del alumno';
        }
    })

    requiredFields4.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar aptitud del alumno';
        }
    })

    requiredFields5.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar nivel del alumno';
        }
    })

    requiredFields6.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar grado del alumno';
        }
    })

    requiredFields7.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar grupo del alumno';
        }
    })
    //--------------------------------------------------------------------------------------------------------

    if (!values.apellidopaterno || values.apellidopaterno === "") {
        errors.apellidopaterno = "Debes ingresar apellido paterno de alumno";
    }

    if (!values.apellidomaterno || values.apellidomaterno === "") {
        errors.apellidomaterno = "Debes ingresar apellido materno de alumno";
    }

    if (!values.nombres || values.nombres === "") {
        errors.nombres = "Debes ingresar nombres de alumno";
    }

    if (!values.fechanacimiento || values.fechanacimiento === "") {
        errors.fechanacimiento = "Debes ingresar fecha del alumno";
    }

    if (!values.estadonacimiento || values.estadonacimiento === "") {
        errors.estadonacimiento = "Debes ingresar estado de nacimiento del alumno";
    }

    if (values.discapacidad === "SI") {
        if (values.discapacidaddescripcion == "") {
            errors.discapacidaddescripcion = "Debes seleccionar el tipo de discapacidad (Describir Discapacidad)";
        }
    }

    if (values.discapacidaddescripcion == "Otra") {
        if (!values.otra || values.otra === "") {
            errors.otra = "Debes ingresar qué otro tipo de discapacidad tiene el alumno";
        }
    }

    if (values.aptitud === "SI") {
        if (values.aptituddescripcion == "") {
            errors.aptituddescripcion = "Debes describir el tipo de aptitud";
        }
    }

    if (!values.calle || values.calle === "") {
        errors.calle = "Debes ingresar calle del alumno";
    }

    if (!values.numero || values.numero === "") {
        errors.numero = "Debes ingresar número del alumno";
    }

    if (!values.colonia || values.colonia === "") {
        errors.colonia = "Debes ingresar colonia del alumno";
    }

    if (!values.municipio || values.municipio === "") {
        errors.municipio = "Debes ingresar municipio del alumno";
    }

    if (!values.codigopostal || values.codigopostal === "") {
        errors.codigopostal = "Debes ingresar código postal del alumno";
    }

    if (!values.telefono || values.telefono === "") {
        errors.telefono = "Debes ingresar teléfono del alumno";
    }

    
    if (!values.clave || values.clave === "") {
        errors.clave = "Debes ingresar clave numérica";
    }
    

    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}

const renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Sexo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'sexo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField2 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Discapacidad</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'discapacidad',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField3 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Describir Discapacidad</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'discapacidaddescripcion',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField4 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Aptitud</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'aptitud',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField5 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Nivel</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'nivel',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField6 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Grado</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'nivel2',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField7 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Grupo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'grupo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField8 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Tutor</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'idtutor',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )


const renderSelectFieldAnoNacimiento = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
    <FormControl error={touched && error}>
        <InputLabel htmlFor="age-native-simple">Año</InputLabel>
        <Select
            native
            {...input}
            {...custom}
            inputProps={{
                name: 'ano',
                id: 'age-native-simple'
            }}
        >
            {children}
        </Select>
        {renderFromHelper({ touched, error })}
    </FormControl>
)

const renderSelectFieldMesNacimiento = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
    <FormControl error={touched && error}>
        <InputLabel htmlFor="age-native-simple">Mes</InputLabel>
        <Select
            native
            {...input}
            {...custom}
            inputProps={{
                name: 'mes',
                id: 'age-native-simple'
            }}
        >
            {children}
        </Select>
        {renderFromHelper({ touched, error })}
    </FormControl>
)

const renderSelectFieldDiaNacimiento = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
    <FormControl error={touched && error}>
        <InputLabel htmlFor="age-native-simple">Día</InputLabel>
        <Select
            native
            {...input}
            {...custom}
            inputProps={{
                name: 'dia',
                id: 'age-native-simple'
            }}
        >
            {children}
        </Select>
        {renderFromHelper({ touched, error })}
    </FormControl>
)


/*
const renderDateTimePicker = ({ input: { onChange, value }, showTime }) =>
    <DateTimePicker
        onChange={onChange}
        format="yyyy/MM/dd"
        time={showTime}
        value={!value ? null : new Date(value)}
    />
*/

const mapStateToProps = (state) => {
    
    const Alumno = Object.values(state.AlumnoReducer.getAlumnoDetail);

    let idtutor                 = "";
    let apellidopaterno         = "";
    let apellidomaterno         = "";
    let nombres                 = "";
    let sexo                    = "";   //Femenino,Masculino
    let fechanacimiento         = "2023-01-01";
    let estadonacimiento        = "";
    let discapacidad            = "";   //SI,NO
    let discapacidaddescripcion = "";   //Autismo, Baja Vision, Ceguera, Discapacidad Intelectual, Discapacidad Multiple, Hipoacusia, Otra
    let otra                    = "";
    let aptitud                 = "";   //NO,SI
    let aptituddescripcion      = "";
    let calle                   = "";
    let numero                  = "";
    let colonia                 = "";
    let municipio               = "";
    let codigopostal            = "";
    let telefono                = "";
    let nivel                   = "";   //Kinder,Preparatoria,Primaria,Secundaria
    let nivel2                  = "";   //1,2,3,4,5,6
    let grupo                   = "";   //A,B,C
    let turno                   = "";   
    let nombretutor             = "";

    let ano_nacimiento          = "";
    let mes_nacimiento          = "";
    let dia_nacimiento          = "";

    let clave                   = "";
    let clavecreada             ="";

    Alumno.map(item => {
        
        idtutor                 = item.idtutor;
        apellidopaterno         = item.apellidopaterno.trim();
        apellidomaterno         = item.apellidomaterno.trim();
        nombres                 = item.nombres.trim();
        sexo                    = item.sexo.trim();
        fechanacimiento         = item.fechanacimiento.trim();
        estadonacimiento        = item.estadonacimiento.trim();
        discapacidad            = item.discapacidad.trim();
        discapacidaddescripcion = item.discapacidaddescripcion.trim();
        otra                    = item.otra.trim();
        aptitud                 = item.aptitud.trim();
        aptituddescripcion      = item.aptituddescripcion.trim();
        calle                   = item.calle.trim();
        numero                  = item.numero.trim();
        colonia                 = item.colonia.trim();
        municipio               = item.municipio.trim();
        codigopostal            = item.codigopostal;
        telefono                = item.telefono.trim();
        nivel                   = item.nivel.trim();
        nivel2                  = item.nivel2;
        grupo                   = item.grupo.trim();
        turno                   = item.turno.trim();
        nombretutor             = item.nombretutor.trim();
        ano_nacimiento          = item.ano_nacimiento.trim();
        mes_nacimiento          = item.mes_nacimiento.trim();
        dia_nacimiento          = item.dia_nacimiento.trim();
        clavecreada             = item.clave.trim();
    })

    //console.log("JAvier---->" + nombretutor);
    
    return {

        initialValues: {
            idtutor,
            apellidopaterno,
            apellidomaterno,
            nombres,
            sexo,
            fechanacimiento,
            estadonacimiento,
            discapacidad,
            discapacidaddescripcion,
            otra,
            aptitud,
            aptituddescripcion,
            calle,
            numero,
            colonia,
            municipio,
            codigopostal,
            telefono,
            nivel,
            nivel2,
            grupo,
            turno,
            nombretutor,
            ano_nacimiento,
            mes_nacimiento,
            dia_nacimiento,
            clave,
            clavecreada,
        }
    };



}; //END MAPSTATETOPROPS

const arreglotutor = [];

class FormAlumno extends Component {

    render() {

        return (
            <form onSubmit={this.props.handleSubmit}>

                <FormGroup row>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                disabled
                                type="text"
                                name="nombretutor"
                                component={renderField}
                                label="Nombre Tutor :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="nombres"
                                component={renderField}
                                label="Nombres :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidopaterno"
                                component={renderField}
                                label="Apellido Paterno :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidomaterno"
                                component={renderField}
                                label="Apellido Materno :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>

                            <Field
                                name="sexo"
                                component={renderSelectField}
                            >
                                <option value="" />
                                <option value={'Femenino'}>Femenino</option>
                                <option value={'Masculino'}>Masculino</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <label>Fecha Nacimiento :</label>

                            <Field
                                name="ano_nacimiento"
                                component={renderSelectFieldAnoNacimiento}
                            >
                                <option value="" />
                                <option value={'2023'}>2023</option>
                                <option value={'2022'}>2022</option>
                                <option value={'2021'}>2021</option>
                                <option value={'2020'}>2020</option>
                                <option value={'2019'}>2019</option>
                                <option value={'2018'}>2018</option>
                                <option value={'2017'}>2017</option>
                                <option value={'2016'}>2016</option>
                                <option value={'2015'}>2015</option>
                                <option value={'2014'}>2014</option>
                                <option value={'2013'}>2013</option>
                                <option value={'2012'}>2012</option>
                                <option value={'2011'}>2011</option>

                                <option value={'2010'}>2010</option>
                                <option value={'2009'}>2009</option>
                                <option value={'2008'}>2008</option>
                                <option value={'2007'}>2007</option>
                                <option value={'2006'}>2006</option>
                                <option value={'2005'}>2005</option>
                                <option value={'2004'}>2004</option>
                                <option value={'2003'}>2003</option>
                                <option value={'2002'}>2002</option>
                                <option value={'2001'}>2001</option>
                                <option value={'2000'}>2000</option>

                                <option value={'1999'}>1999</option>
                                <option value={'1998'}>1998</option>
                                <option value={'1997'}>1997</option>
                                <option value={'1996'}>1996</option>
                                <option value={'1995'}>1995</option>
                                <option value={'1994'}>1994</option>
                                <option value={'1993'}>1993</option>
                                <option value={'1992'}>1992</option>
                                <option value={'1991'}>1991</option>
                                <option value={'1990'}>1990</option>

                                <option value={'1989'}>1989</option>
                                <option value={'1988'}>1988</option>
                                <option value={'1987'}>1987</option>
                                <option value={'1986'}>1986</option>
                                <option value={'1985'}>1985</option>
                                <option value={'1984'}>1984</option>
                                <option value={'1983'}>1983</option>
                                <option value={'1982'}>1982</option>
                                <option value={'1981'}>1981</option>
                                <option value={'1980'}>1980</option>

                            </Field>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Field
                                name="mes_nacimiento"
                                component={renderSelectFieldMesNacimiento}
                            >
                                <option value="" />
                                <option value={'1'}>ENERO</option>
                                <option value={'2'}>FEBRERO</option>
                                <option value={'3'}>MARZO</option>
                                <option value={'4'}>ABRIL</option>
                                <option value={'5'}>MAYO</option>
                                <option value={'6'}>JUNIO</option>
                                <option value={'7'}>JULIO</option>
                                <option value={'8'}>AGOSTO</option>
                                <option value={'9'}>SEPTIEMBRE</option>
                                <option value={'10'}>OCTUBRE</option>
                                <option value={'11'}>NOVIEMBRE</option>
                                <option value={'12'}>DICIEMBRE</option>

                            </Field>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Field
                                name="dia_nacimiento"
                                component={renderSelectFieldDiaNacimiento}
                            >
                                <option value="" />
                                <option value={'1'}>1</option>
                                <option value={'2'}>2</option>
                                <option value={'3'}>3</option>
                                <option value={'4'}>4</option>
                                <option value={'5'}>5</option>
                                <option value={'6'}>6</option>
                                <option value={'7'}>7</option>
                                <option value={'8'}>8</option>
                                <option value={'9'}>9</option>
                                <option value={'10'}>10</option>
                                <option value={'11'}>11</option>
                                <option value={'12'}>12</option>
                                <option value={'13'}>13</option>
                                <option value={'14'}>14</option>
                                <option value={'15'}>15</option>
                                <option value={'16'}>16</option>
                                <option value={'17'}>17</option>
                                <option value={'18'}>18</option>
                                <option value={'19'}>19</option>
                                <option value={'20'}>20</option>
                                <option value={'21'}>21</option>
                                <option value={'22'}>22</option>
                                <option value={'23'}>23</option>
                                <option value={'24'}>24</option>
                                <option value={'25'}>25</option>
                                <option value={'26'}>26</option>
                                <option value={'27'}>27</option>
                                <option value={'28'}>28</option>
                                <option value={'29'}>29</option>
                                <option value={'30'}>30</option>
                                <option value={'31'}>31</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="estadonacimiento"
                                component={renderField}
                                label="Estado Nacimiento :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>

                            <Field
                                name="discapacidad"
                                component={renderSelectField2}
                            >
                                <option value="" />
                                <option value={'SI'}>SI</option>
                                <option value={'NO'}>NO</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>

                            <Field
                                name="discapacidaddescripcion"
                                component={renderSelectField3}
                            >
                                <option value="" />
                                <option value={'Autismo'}>Autismo</option>
                                <option value={'Baja Vision'}>Baja Vision</option>
                                <option value={'Ceguera'}>Ceguera</option>
                                <option value={'Discapacidad Intelectual'}>Discapacidad Intelectual</option>
                                <option value={'Discapacidad Multiple'}>Discapacidad Multiple</option>
                                <option value={'Hipoacusia'}>Hipoacusia</option>
                                <option value={'Otra'}>Otra</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="otra"
                                component={renderField}
                                label="Otra :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>

                            <Field
                                name="aptitud"
                                component={renderSelectField4}
                            >
                                <option value="" />
                                <option value={'NO'}>NO</option>
                                <option value={'SI'}>SI</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="aptituddescripcion"
                                component={renderField}
                                label="Describir Aptitud :"
                            />
                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="calle"
                                component={renderField}
                                label="Calle :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="numero"
                                component={renderField}
                                label="Numero :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="colonia"
                                component={renderField}
                                label="Colonia :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="municipio"
                                component={renderField}
                                label="Municipio :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="number"
                                name="codigopostal"
                                component={renderField}
                                label="Código Postal :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="number"
                                name="telefono"
                                component={renderField}
                                label="Teléfono :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="nivel"
                                component={renderSelectField5}
                            >
                                <option value="" />
                                <option value={'Maternal'}>Maternal</option>
                                <option value={'Kinder'}>Kinder</option>
                                <option value={'Preparatoria'}>Preparatoria</option>
                                <option value={'Primaria'}>Primaria</option>
                                <option value={'Secundaria'}>Secundaria</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="nivel2"
                                component={renderSelectField6}
                            >
                                <option value="" />
                                <option value={'0'}>NA</option>
                                <option value={'1'}>1</option>
                                <option value={'2'}>2</option>
                                <option value={'3'}>3</option>
                                <option value={'4'}>4</option>
                                <option value={'5'}>5</option>
                                <option value={'6'}>6</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="grupo"
                                component={renderSelectField7}
                            >
                                <option value="" />
                                <option value={'0'}>NA</option>
                                <option value={'A'}>A</option>
                                <option value={'B'}>B</option>
                                <option value={'C'}>C</option>
                                <option value={'D'}>D</option>
                                <option value={'E'}>E</option>
                                <option value={'F'}>F</option>
                                <option value={'G'}>G</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        
                        <FormGroup>
                            <Field type="text" name="clavecreada" component={renderField} disabled />
                            <Field
                                type="number"
                                name="clave"
                                component={renderField}
                                label="Clave (6 dígitos): "
                            />
                        </FormGroup>
                    </Col>
                   

                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

FormAlumno = reduxForm({
    form: "formAlumno",
    validate,
    enableReinitialize: true,
})(FormAlumno);
export default connect(mapStateToProps, null)(FormAlumno);
